import { PaginatedDataSheetLogisticsEstimates } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { RefObject } from 'react'

import { DataSheetLogisticsRow } from 'views/CalculateEmissions/index'

const DataSheetLogisticsTable = ({
    paginatedEstimates,
    currentPage,
    pageHistoryRef,
    queryParams,
    loading,
}: {
    paginatedEstimates?: PaginatedDataSheetLogisticsEstimates
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    loading: boolean
}) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedEstimates?.data.length ? '1200px' : 'auto' }}
                stickyHeader
                loading={!paginatedEstimates || loading}
                empty={!loading && !paginatedEstimates?.data.length}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={4}>Origin</TableNew.TableCell>
                        <TableNew.TableCell colSize={4}>Destination</TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            Legs
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={2} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {paginatedEstimates?.data.map((calculation, i: number) => (
                            <DataSheetLogisticsRow
                                key={i}
                                calculation={calculation}
                                currentPage={currentPage}
                                pageHistoryRef={pageHistoryRef}
                                queryParams={queryParams}
                            />
                        ))}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default DataSheetLogisticsTable
